export default "__VITE_ASSET__KOfReHvG__"